import { SBaseDisplay } from '@summit/core';

import { EboObjectTimeLineSd } from '../base-classes/ebo-object-time-line-sd';
import { ITenantItem } from './i-tenant-item';
import { Tenant } from './tenant';
import { TenantFeatures } from './tenant-features';

export class TenantSubscription extends EboObjectTimeLineSd implements ITenantItem, SBaseDisplay {
  tenantID: string;
  tenant: Tenant;
  invoiceCycleDate: number;
  pricePerTruck: number;
  discount: number;
  truckOverride: number;
  comment: number;
  features: TenantFeatures;

  constructor(jsonData?: Partial<TenantSubscription>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.tenant) this.tenant = new Tenant(jsonData.tenant);
      if (jsonData.features) this.features = new TenantFeatures(jsonData.features);
    }
    this.effectiveDate = this.effectiveDate.startOf('day');
    this.features ??= new TenantFeatures();
  }

  toShortString(): string {
    return `${this.effectiveDate.format('M/D')}`;
  }
}
